import { useState, useEffect, useRef, Fragment } from 'react';
import { useReactToPrint } from 'react-to-print';
import PropTypes from 'prop-types';
import { capitalCase } from 'change-case';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Autocomplete,
  TextField,
  List,
  ListItem,
  ListItemText,
  Popover,
  Tooltip,
  Tabs,
  Tab,
  Switch
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import Label from 'src/components/Label';
import Scrollbar from 'src/components/Scrollbar';
import RecipeLog from 'src/pages/dashboard/RecipeLog';
import AddProducts from 'src/components/_dashboard/blog/AddProducts';
import JobCost from 'src/pages/dashboard/receipe';
import { Icon } from '@iconify/react';
import editFill from '@iconify/icons-eva/edit-fill';
import { BASE_URL_QR, COMPANY_NAME, REST_API_END_POINT, UNITS } from 'src/constants/Defaultvalues';
import useCompanyProfile from 'src/hooks/useCompanyProfile';
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal';
import QRCode from 'react-qr-code';
import { fCurrency } from 'src/utils/formatNumber';
import Modal from './_dashboard/blog/ProjectModel';
import { Print, VisibilityRounded } from '@material-ui/icons';
import emailFillIcon from '@iconify/icons-eva/email-fill';
import moment from 'moment';
import MaterialFinishedProducts from 'src/pages/dashboard/MaterialFinishedProducts';
import MaterialPartialFinishedProducts from 'src/pages/dashboard/MaterialPartialFinishedProducts';
import AnimatedButton from './animate/AnimatedButton';
import { IconButton } from '@mui/material';

ViewProductFormulaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  fromTask: PropTypes.bool,
  formulaId: PropTypes.number,
  explodedPermissions: PropTypes.array,
  user: PropTypes.object, // Pass the entire user object to access user_id and user_type
};

export default function ViewProductFormulaModal({
  open,
  fromTask,
  onClose,
  formulaId,
  explodedPermissions,
  user,
  onRecipeUpdated,
  fetchNewSelectedProducts,
  hideEdit,
  hidePrintAndEmail,
}) {
  const theme = useTheme();
  const componentRef = useRef();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const { COMPANY_LOGO, COMPANY_NAME,companyAddressLine1 ,companyAddressLine2,companyTelephone} = useCompanyProfile();
  const [localData, setLocalData] = useState(null);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [isMaterialsLoading, setIsMaterialsLoading] = useState(false);
  const [isServicesLoading, setIsServicesLoading] = useState(false);
  const [openCatalogModal, setOpenCatalogModal] = useState(false);
  const [selectedRecipeForCatalog, setSelectedRecipeForCatalog] = useState(null);
  const [openCatalogTypeDialog, setOpenCatalogTypeDialog] = useState(false);
  const [selectedCatalogType, setSelectedCatalogType] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [serviceAnchorEl, setServiceAnchorEl] = useState(null);
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0 });
  const [currentSubCategory, setCurrentSubCategory] = useState(null);
  const [currentService, setCurrentService] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [isViewMaterialLoading, setIsViewMaterialLoading] = useState(false);
  const [activeMaterialId, setActiveMaterialId] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [qbCategory, setQbCategory] = useState(null);
  const [qbSubCategory, setQbSubCategory] = useState(null);
  const [allAccounts, setAllAccounts] = useState([]);
  const [avaTaxCategory, setAvaTaxCategory] = useState([]);
  const [currentTab, setCurrentTab] = useState('Finished Products');
  const [openRecipeModal, setOpenRecipeModal] = useState(false);
  const [openInvoiceEmailModal, setOpenInvoiceEmailModal] = useState(false);
  const [invoicePdfData, setInvoicePdfData] = useState([]);
  const [changeMaterialnameToggle, setChangeMaterialnameToggle] = useState(false);

  const handleRecipeUpdated = async(updatedRecipe) => {
    fetchRecipeData(formulaId);
    fetchRecipeProductData(formulaId);
    fetchRecipeServiceData(formulaId);
    setOpenRecipeModal(false);
    if (onRecipeUpdated) {
      onRecipeUpdated(updatedRecipe);
    }
  };

  const ACCOUNT_TABS = [
    { value: 'Partial Finished Products' },
    { value: 'Finished Products' },
  ];
  const incomeAccount = [{ id: 1, name: 'Income Account' }, { id: 3, name: 'Accounts Payable' }, { id: 4, name: 'Inventory Asset' }];

  const catalogTypeOptions = [
    { id: 'production_catalog', label: 'Production Catalog', inhouse: true, isTrafficCatalog: false, selectedTab: undefined },
    { id: 'in_stock_catalog', label: 'In Stock Catalog', inhouse: 4, isTrafficCatalog: false, selectedTab: 'in_stock_catalog' },
    { id: 'client_owned_catalog', label: 'Client Owned Catalog', inhouse: 5, isTrafficCatalog: false, selectedTab: 'client_owned_catalog' },
  ];

  const fetchRecipeData = async (id) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-recipe-by-id`, { id });
      if (response.data.status === 1) {
        setLocalData(response.data.data);
      } else {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error("Error fetching recipe data:", error);
      enqueueSnackbar("Failed to fetch recipe data.", { variant: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRecipeProductData = async (id) => {
    setIsMaterialsLoading(true);
    try {
      const response = await axios.post(`${REST_API_END_POINT}recipe/get-all-materials`, { userId: user.user_id, params: id });
      const productListData = response.data.results;
      const selectedMaterials = response.data.selectedMaterials[0]?.ingredients || [];
      
      if (selectedMaterials.length > 0) {
        setSelectedProjects(
          productListData
            .filter(item1 =>
              selectedMaterials.some(item2 => item1.id === item2.product_id)
            )
            .flatMap(item1 => {
              let matches = selectedMaterials.filter(item2 => item1.id === item2.product_id);
              return matches.map(match => ({
                ...item1,
                product_id: match.id,
                quantity: match.quantity,
                max_price: 0,
                initial_max_price: match?.stockType == 2 ? match?.max_partial_unit_cost : item1.max_price || item1.special_price || 0,
                initialQty: match.quantity || 1,
                partialProductQty: match.total_partial_stock,
                convertionUnit: match?.convertionUnit || null,
                width: match?.width || null,
                stockType: match?.stockType || 1,
                unit: match?.stockType == 2 ? match?.convertionUnit : match?.unit,
                convertionQty: match?.convertionQty || null,
              }));
            })
        );        
      } else {
        setSelectedProjects([]);
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      setSelectedProjects([]);
    } finally {
      setIsMaterialsLoading(false);
    }
  };

  const fetchRecipeServiceData = async (id) => {
    setIsServicesLoading(true);
    try {
      const response = await axios.post(`${REST_API_END_POINT}recipe/get-all-services`, { userId: user.user_id, params: id });
      const productListData = response.data.results.filter(row => row.inhouse !==2);
      const selectedServices = response.data.selectedMaterials[0]?.services.filter(row => row.inhouse !==2) || [];
      
      if (selectedServices.length > 0) {
        setSelectedServices(
          productListData.filter(item1 =>
            selectedServices.some(item2 => item1.id === item2.service_id)
            
          ).map(item1 => {
            console.log("item1item1item1item1",item1);
            
            const match = selectedServices.find(item2 => item1.id === item2.service_id);
            console.log("item1item1item1item12",match);
            
            
            return { ...item1, ...(match ? { service_id: match.id, quantity: match.quantity, cost: item1.cost ?? 0, markup: match?.markup || 0 } : {}) };
          })
        );
      } else {
        setSelectedServices([]);
      }
    } catch (error) {
      console.error("Error fetching service data:", error);
      setSelectedServices([]);
    } finally {
      setIsServicesLoading(false);
    }
  };

  useEffect(() => {
    if (open && formulaId) {
      fetchRecipeData(formulaId);
      fetchRecipeProductData(formulaId);
      fetchRecipeServiceData(formulaId);
    } else if (!open) {
      setLocalData(null);
      setSelectedProjects([]);
      setSelectedServices([]);
      setIsMaterialsLoading(false);
      setIsServicesLoading(false);
    }
  }, [open, formulaId, user]);

  const handleOpenCatalogModal = (row) => {
    setSelectedRecipeForCatalog(row);
    if (localData?.type === 1) {
      setOpenCatalogTypeDialog(true);
    } else {
      setOpenCatalogModal(true);
    }
  };

  const handleCatalogTypeSelect = (catalogType) => {
    setSelectedCatalogType(catalogType);
    setOpenCatalogTypeDialog(false);
    setOpenCatalogModal(true);
  };

  const handleCloseCatalogTypeDialog = () => {
    setOpenCatalogTypeDialog(false);
    setSelectedCatalogType(null);
    setSelectedRecipeForCatalog(null);
  };

  const handlePopoverOpen = (event,subCategory) => {
    setAnchorEl(event.currentTarget);
    setCurrentSubCategory(subCategory);
    setAnchorPosition({ top: event.clientY, left: event.clientX });
  };

  const handleServicePopoverOpen = (event,service) => {
    setServiceAnchorEl(event.currentTarget);
    setCurrentService(service);
    setAnchorPosition({ top: event.clientY, left: event.clientX });
  };
  

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleServicePopoverClose = () => {
    setServiceAnchorEl(null);
  };

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const getVendorNamesString = (vendorIds) => {
    if (!vendorIds) return '';
    const ids = String(vendorIds)
      .split(',')
      .map((id) => parseInt(id.trim(), 10))
      .filter((id) => !Number.isNaN(id));
    return vendors
      .filter((vendor) => ids.includes(vendor.id))
      .map((vendor) => vendor.name)
      .join(', ');
  };

  const fetchMaterialSupportData = async (materialRow) => {
    try {
      const [accountsRes, avaRes, qbCategoryRes] = await Promise.all([
        axios.post(`${REST_API_END_POINT}product/get-qb-accounts`),
        axios.post(`${REST_API_END_POINT}avalara/get-all-tax-category`),
        axios.post(`${REST_API_END_POINT}product/get-qb-categories`),
      ]);

      setAllAccounts(accountsRes?.data?.status === 1 ? (accountsRes?.data?.result || []) : []);
      setAvaTaxCategory(avaRes?.data?.result || []);

      if (qbCategoryRes?.data?.status === 1) {
        const allItems = qbCategoryRes?.data?.result || [];
        const foundCategory = allItems.find((cat) => String(cat.Id) === String(materialRow?.qb_category)) || null;
        const foundSubCategory = allItems.find((sub) => String(sub.Id) === String(materialRow?.qb_sub_category)) || null;
        setQbCategory(foundCategory ? foundCategory.Name : null);
        setQbSubCategory(foundSubCategory ? foundSubCategory.Name : null);
      } else {
        setQbCategory(null);
        setQbSubCategory(null);
      }
    } catch (error) {
      console.error('Error fetching material support data:', error);
      setAllAccounts([]);
      setAvaTaxCategory([]);
      setQbCategory(null);
      setQbSubCategory(null);
    }
  };

  const handleViewMaterialById = async (materialId) => {
    if (!materialId) return;
    setIsViewMaterialLoading(true);
    setActiveMaterialId(materialId);
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-materials`, {
        userId: user?.user_id,
        userType: user?.user_type,
        isVendor: 1,
      });

      const materialList = response?.data?.results || [];
      setVendors(response?.data?.vendorData?.data || []);
      const selectedMaterial = materialList.find((item) => Number(item?.id) === Number(materialId));
      if (!selectedMaterial) {
        enqueueSnackbar('Material not found.', { variant: 'error' });
        return;
      }

      setViewData(selectedMaterial);
      // Loader is only for modal-opening action, not background support-data loading
      setIsViewMaterialLoading(false);
      setActiveMaterialId(null);
      await fetchMaterialSupportData(selectedMaterial);
    } catch (error) {
      console.error('Error fetching material details by id:', error);
      enqueueSnackbar('Failed to load material details.', { variant: 'error' });
    } finally {
      setIsViewMaterialLoading(false);
      setActiveMaterialId(null);
    }
  };

  const handleSendproductFormulaEmail = () => {
    if (!localData) {
      enqueueSnackbar('Formula data not available', { variant: 'warning' });
      return;
    }

    const formulaPdfObject = {
      id: `formula_${formulaId}`,
      name: `${localData?.name || 'product_formula'}_${moment().format('YYYY-MM-DD')}.pdf`,
      file_type: 'application/pdf',
      extension: 'pdf',
      url: null,
      invoiceData: {
        formulaData: localData,
        materials: selectedProjects,
        services: selectedServices,
      }
    };
    
    setInvoicePdfData([formulaPdfObject]);
    setOpenInvoiceEmailModal(true);
  };
  const handleSendproductFormulaPDF = useReactToPrint({
    content: () => componentRef.current,
   pageStyle: `
  @page { 
    size: A3; 
    margin: 12mm; 
  }

  @media print {
    .print-header { display: block !important; margin-bottom: 30px; }
    .no-print { display: none !important; }
    body { -webkit-print-color-adjust: exact; }
  }

  .print-header {
  display: none; /* hidden on screen */
}

@media print {
  .print-header {
    display: block !important;
  }
}

  body {
    font-family: 'Public Sans', sans-serif;
    font-size: 12pt;
    color: #000 !important;
    background: #fff !important;

    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  /* FORCE EVERYTHING TO BE BLACK */
  * {
    color: #000 !important;
    opacity: 1 !important;
    text-shadow: none !important;
    filter: none !important;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    border: 1px solid #000 !important;
    padding: 6px;
    font-size: 12pt !important;
    font-weight: 500 !important;
     color: #000 !important; 
  }

  th {
    font-weight: 700 !important;
    background: #f2f2f2 !important;
    color: #000 !important; 
  }
   
    }

  /* FIX TYPOGRAPHY VISIBILITY */
  p, span, div {
    color: #000 !important;
  }

  /* REMOVE ANY MUI FADING */
  .MuiTypography-root {
  color: #000 !important;
  display: block !important;
}

  /* REMOVE POSSIBLE SCROLL/TRANSFORM ISSUES */
  .MuiBox-root, .MuiStack-root {
    transform: none !important;
  }
`,
  });

  const resolvedViewUnitName =
    viewData?.unit_name ||
    UNITS?.find((item) => Number(item?.id) === Number(viewData?.unit))?.name ||
    'Unit';

  return (
    // <Dialog
    //   open={open}
    //   onClose={onClose}
    //   maxWidth="md"
    //   fullWidth
    // >
       <Modal
        modalTitle={localData?.type === 1 ? "View Production Formula" : localData?.type === 2 ? "View Traffic Formula" : "View Split Formula"}
        open={open ? true : false}
        width={1000}
        handleClose={() => {
          onClose();
        }}
      >
      {/* <DialogTitle>{selectedTab === "production" ? "View Production Formula" : selectedTab === "traffic" ? "View Traffic Formula" : "View Split Formula"}</DialogTitle> */}
      {/* <DialogContent dividers> */}
   {isMaterialsLoading && isServicesLoading ? "" : !hidePrintAndEmail && <Stack direction="row"
  alignItems="flex-end"
  justifyContent="flex-end"
  sx={{ width: '100%', gap:2,mb:2 }}>
         <Tooltip title={'Send Product formula PDF via Email'}>
                        <IconButton  
                          onClick={handleSendproductFormulaEmail}
                          color="primary"
                          sx={{
                            backgroundColor: (theme) => theme.palette.primary.main,
                            color: (theme) => theme.palette.primary.contrastText,
                            '&:hover': {
                              backgroundColor: (theme) => theme.palette.primary.dark,
                            },
                          }}
                        >
                          <Icon icon={emailFillIcon} width={24} height={24} />
                        </IconButton>
                      </Tooltip>
       <AnimatedButton title="Print" startIcon={<Print />} size="small" onClick={handleSendproductFormulaPDF} />
   </Stack>}
        {isLoading || !localData ? (
          <Stack alignItems='center' justifyContent='center'>
            <CircularProgress color="primary" variant="indeterminate" />
          </Stack>
        ) : (
          <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
            <Grid item xs={12} md={12}>
              <Stack
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }}
                spacing={3}
              >
                <Paper
                  key={'ddf'}
                  sx={{
                    p: 3,
                    width: 1,
                    bgcolor: 'background.neutral'
                  }}
                >
                 <div ref={componentRef}>
                 <div className="print-header" style={{display:'none'}}>
  <div style={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: '2px solid #1ccaff',
    paddingBottom: '20px',
    marginBottom: '20px'
  }}>
    
    <div>
      <img
        src={COMPANY_LOGO}
        alt="Company Logo"
        style={{ width: '150px', marginBottom: '10px' }}
      />
      <Typography variant="h6" style={{ margin: 0 }}>
        {COMPANY_NAME}
      </Typography>
          {companyAddressLine1}<br/>
          {companyAddressLine2}<br/>
          {companyTelephone}
    </div>

    <div style={{ textAlign: 'right' }}>
      <Typography variant="h4" style={{ color: '#1ccaff', margin: 0 }}>
        {localData?.type === 1
          ? "Production Formula"
          : localData?.type === 2
          ? "Traffic Formula"
          : "Split Formula"}
      </Typography>

      <Typography variant="body1">
        <strong>Name:</strong> {localData?.name}
      </Typography>

      <Typography variant="body1">
        <strong>Date:</strong> {moment().format('YYYY-MM-DD')}
      </Typography>
    </div>

  </div>
</div>
                  <Box className="no-print" sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="subtitle1" gutterBottom sx={{ wordBreak: 'break-word' }}>
                        <span style={{ color: localData?.name ? 'inherit' : 'inherit' }}>
                          {localData?.type === 1 ? "Production Formula Name" : localData?.type === 2 ? "Traffic Formula Name" : "Split Formula Name"}: {localData?.name}
                        </span>
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Status :{' '}
                        <Label
                          variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                          color={(localData?.status === 1 && 'success') || 'error'}
                        >
                          {(localData?.status === 1) ? " Active" : " Inactive"}
                        </Label>
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        gap: 1,
                        flexShrink: 0,
                      }}
                    >
                      {!hideEdit && (
                        <Button
                          variant="outlined"
                          startIcon={<Icon icon={editFill} />}
                          onClick={() => setOpenRecipeModal(true)}
                          sx={{
                            whiteSpace: 'nowrap',
                            minWidth: 'auto',
                          }}
                        >
                          Edit Formula
                        </Button>
                      )}
                      {localData?.type === 1 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, whiteSpace: 'nowrap' }}>
                          <Typography variant="body2">Name</Typography>
                          <Switch
                            checked={changeMaterialnameToggle}
                            onChange={(e) => setChangeMaterialnameToggle(e.target.checked)}
                          />
                          <Typography variant="body2">Description</Typography>
                        </Box>
                      )}
                    </Box>
                  </Box>
                  <Scrollbar>
                    {(isMaterialsLoading || selectedProjects?.length > 0) &&
                      (isMaterialsLoading ? (
                        <Stack alignItems="center" justifyContent="center" sx={{ py: 4 }}>
                          <CircularProgress size={28} />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading materials...
                          </Typography>
                        </Stack>
                      ) : (
                        <>
                        <Box className='no-print' sx={{ width:"100%", display:"flex", alignItems:'center', justifyContent:"space-between", my:2, mr:5 }}>
                          <Typography variant="body2" gutterBottom>Materials</Typography>
                          {/* <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr:2 }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? "#ff5b78" : "#ffc0cb", borderRadius: "20%", border: "1px solid black" }} />
                              <Typography variant="body2">From Partial</Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Box sx={{ width: 20, height: 20, backgroundColor: theme.palette.mode === 'light' ? "#9c7d7d" : "#ffffff", borderRadius: "20%", border: "1px solid black" }} />
                              <Typography variant="body2">From Finished</Typography>
                            </Box>
                          </Box> */}
                        </Box>
                        <TableContainer sx={{ maxWidth: '100%', border: '1px solid', borderColor: theme.palette.divider }}>
                          <Table>
                            <TableHead sx={{ width: '100%' }}>
                              <TableRow>
                                {fromTask ? (
                                  <>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>#</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>{changeMaterialnameToggle ? "Description" : "Name"}</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>Qty</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>QR Code</Typography>
                                    </TableCell>
                                  </>
                                ) : (
                                  <>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>#</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>{changeMaterialnameToggle ? "Description" : "Name"}</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>Qty</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>Unit Cost</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>Sub Total</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider, whiteSpace: 'normal', wordBreak: 'break-word',minWidth: '130px', maxWidth: '150px' }}>
                                      <Typography variant="body1">Retail Markup (%)</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider, whiteSpace: 'normal', wordBreak: 'break-word',minWidth: '130px', maxWidth: '150px' }}>
                                      <Typography variant="body1">Retail Amount</Typography>
                                    </TableCell>
                                    <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="body1" noWrap>Total</Typography>
                                    </TableCell>
                                  </>
                                )}
                              </TableRow>
                            </TableHead>

                            <TableBody>
                            {selectedProjects?.map((selectedProject, index) => {
                              let unitName = UNITS?.filter((item) => item?.id == selectedProject?.unit);
                              let newShortUnitName = unitName?.[0]?.short_name || "";
                              let fullUnitName = unitName?.[0]?.name || "";
                              let shortUnitName = newShortUnitName;
                              
                              
                              let totalWithoutMarkup = 0;
                              let retail_markup = selectedProject?.retail_price || 0;
                              let markup_price = 0;
                              let Total = 0;
                              let calculatedPrice = 0;
                              let remainingStockQty = 0;
                              let qtyAfterConversion = 0;
                              let convertionQty = 0
                              const selectedUnit = UNITS.find(unit => unit.id === selectedProject.convertionUnit);
                              const initialUnit = UNITS.find(unit => unit.id === selectedProject.unit);
                              if (true) {
                              // if (selectedProject.stockType == 1 || selectedProject?.unit == 4) {
                                selectedProject.max_price = selectedProject.initial_max_price || 0;
                                totalWithoutMarkup = (Number(selectedProject.initial_max_price) * (selectedProject.quantity || 1));
                                markup_price = (totalWithoutMarkup * retail_markup) / 100;
                                Total = totalWithoutMarkup + markup_price;
                                qtyAfterConversion = selectedProject.quantity || 0;
                              }

                              totalWithoutMarkup = totalWithoutMarkup.toFixed(2);
                              markup_price = markup_price.toFixed(2);
                              Total = Total.toFixed(2);                       
                              return(
                              <TableRow
                                key={selectedProject.id}
                              >
                                <TableCell  sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                  {index+1}
                                </TableCell>

                                <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                  <Box sx={{ maxWidth: 100 }}>
                                    <Typography variant="subtitle2" sx={{ whiteSpace: 'pre-line',color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff', overflowWrap: 'break-word' }}>{changeMaterialnameToggle ? (selectedProject.description||'N/A') : (selectedProject.name||'N/A')}</Typography>
                                  </Box>
                                </TableCell>

                                <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                  <Typography variant="subtitle2" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#9c7d7d' : '#ffffff'}}>{selectedProject?.quantity} {shortUnitName}</Typography>
                                </TableCell>

                                {fromTask ? (
                                  <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                    <Tooltip title={selectedProject.name || ''}>
                                      <Box
                                        sx={{ display: 'flex', justifyContent: 'center', py: 0.5, cursor: 'pointer' }}
                                        onClick={() => handleViewMaterialById(selectedProject?.id)}
                                      >
                                        {isViewMaterialLoading && Number(activeMaterialId) === Number(selectedProject?.id) ? (
                                          <CircularProgress size={20} />
                                        ) : (
                                          <VisibilityRounded />
                                        )}
                                      </Box>
                                    </Tooltip>
                                  </TableCell>
                                ) : (
                                  <>
                                    <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider }}>
                                      <Typography variant="subtitle2" sx={{color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#000000' : '#ffffff'}}>${Number(selectedProject?.initial_max_price).toFixed(2)}</Typography>
                                    </TableCell>

                                    <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider, color:'#1ccaff'}}>{fCurrency(Number(totalWithoutMarkup))}</TableCell>
                                    <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider, color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>{Number(selectedProject.retail_price).toFixed(2)}%</TableCell>
                                    <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider, color: selectedProject.stockType== 2 ? theme.palette.mode === 'light' ? '#ff5b78' : '#ffc0cb' : theme.palette.mode === 'light' ? '#000000' : '#ffffff' }}>{fCurrency(Number(markup_price))}</TableCell>
                                    <TableCell align="center" sx={{ border: '1px solid', borderColor: theme.palette.divider, color:'#fc8c03'}}>{fCurrency(parseFloat(Total)?.toFixed(2))}</TableCell>
                                  </>
                                )}
                              </TableRow>
                            )})}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                      ))
                    }
                    {(isServicesLoading || selectedServices?.length > 0) &&
                      (isServicesLoading ? (
                        <Stack alignItems="center" justifyContent="center" sx={{ py: 4 }}>
                          <CircularProgress size={28} />
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            Loading services...
                          </Typography>
                        </Stack>
                      ) : (
                        <>
                        <Typography variant="body2" gutterBottom sx={{ mt: 2 }}>Services</Typography>
                        <TableContainer sx={{ maxWidth: '100%', mt: 2, border: '1px solid', borderColor: theme.palette.divider }}>
                          <Table>
                            <TableHead sx={{ width: '100%' }}>
                              <TableRow>
                                <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}> <Typography variant="body1" noWrap>#</Typography></TableCell>
                                <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>{changeMaterialnameToggle ? "Description" : "Name"}</Typography></TableCell>
                                {/* <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>Name</Typography></TableCell> */}
                                {!fromTask && <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>Cost (Hourly)</Typography></TableCell>}
                                <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>Hours</Typography></TableCell>
                                {!fromTask && <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>SubTotal</Typography></TableCell>}
                                {!fromTask && <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>Markup (%)</Typography></TableCell>}
                                {!fromTask && <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>Retail Amount</Typography></TableCell>}
                                {!fromTask && <TableCell align='center' sx={{ border: '1px solid', borderColor: theme.palette.divider }}><Typography variant="body1" noWrap>Total</Typography></TableCell>}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                                {selectedServices?.map((row, index) => {
                                  console.log("rowrowrowrowrow",row);
                                  
                                  let totalWithoutMarkup = parseFloat(Number(row.cost || 0) * Number(row.quantity || 0))?.toFixed(2)
                                  let markupPercentage = row?.markup || 0
                                  let markup_price = parseFloat((totalWithoutMarkup * markupPercentage) /100)?.toFixed(2)
                                  let Total = parseFloat(Number(totalWithoutMarkup) + Number(markup_price))?.toFixed(2)
                                  console.log("calculation services--",totalWithoutMarkup,markup_price,Total)
                                return(
                                  <TableRow
                                    hover
                                    key={index}
                                    tabIndex={-1}
                                  >
                                    <TableCell align='center' sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> {index + 1} </TableCell>
                                    <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> {changeMaterialnameToggle ? (row.description||'N/A') : (row.name||'N/A')} </TableCell>
                                    {/* <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> {row.name||'N/A'} </TableCell> */}
                                    {!fromTask && <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> ${row.cost} </TableCell>}
                                    <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> {row.quantity} </TableCell>
                                    {!fromTask && <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> ${parseFloat(totalWithoutMarkup)?.toFixed(2)} </TableCell>}
                                    {!fromTask && <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> {markupPercentage} </TableCell>}
                                    {!fromTask && <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> ${parseFloat(markup_price)?.toFixed(2)} </TableCell>}
                                    {!fromTask && <TableCell align="center" sx={{ border: '0.5px solid', borderColor: theme.palette.divider }}> ${parseFloat(Total)?.toFixed(2)} </TableCell>}
                                  </TableRow>
                                )
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </>
                      ))
                    }
                  </Scrollbar>

                    {!fromTask && <div className="print-header">
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_material_cost_with_markup ? '#fc8c03' : 'grey' }}>
                    Material Cost(Retail) : {localData?.expected_material_cost_with_markup?.toFixed(2)}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_service_cost_with_markup ? '#fc8c03' : 'grey' }}>
                    Service Cost(Retail) : {localData?.expected_service_cost_with_markup?.toFixed(2)}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_install_labor_cost_with_markup ? '#fc8c03' : 'grey' }}>
                    Install Labor(Retail) : {localData?.expected_install_labor_cost_with_markup?.toFixed(2)}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_cost_with_markup ? '#fc8c03' : 'grey' }}>
                      Total Cost(Retail) : {localData?.expected_cost_with_markup?.toFixed(2)}
                    </span>
                  </Typography>

                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_material_cost ? '#1ccaff' : 'grey' }}>
                      Expected Material Cost (Without Mark up) : {localData?.expected_material_cost?.toFixed(2)}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_service_cost ? '#1ccaff' : 'grey' }}>
                      Expected Service Cost (Without Mark up) : {localData?.expected_service_cost?.toFixed(2)}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_install_labor_cost ? '#1ccaff' : 'grey' }}>
                      Expected Install Labor (Without Mark up) : {localData?.expected_install_labor_cost?.toFixed(2)}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                    <span style={{ color: localData?.expected_cost ? '#1ccaff' : 'grey' }}>
                    Total Expected Cost (Without Mark up) : {localData?.type === 3 ? (Number(localData?.expected_cost) + Number(localData?.expected_install_labor_cost)).toFixed(2) : localData?.expected_cost?.toFixed(2)}
                    </span>
                  </Typography>
                  <Typography variant="subtitle1" sx={{ color: '#fa2828', textAlign: 'left', padding: '8px' }}>
                    <span>
                      Please note : Our {localData?.type === 1 ? "Production Formula" : localData?.type === 2 ? "Traffic Formula" : "Split Formula"} costs are expected costs and may vary based on the materials chosen for a job.
                    </span>
                  </Typography>
                  
                  </div>
                  }
                 </div>
                </Paper>
                <Stack className="no-print">
                  <RecipeLog id={formulaId} selectedTab={localData?.type === 1 ? 'production' : localData?.type === 2 ? 'traffic' : 'split'} isJobCost={true} changeMaterialnameToggle={changeMaterialnameToggle}/>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        )}
      {/* </DialogContent> */}
      {/* <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Close
        </Button>
      </DialogActions> */}

      {/* Catalog Type Selection Dialog for Production Formula */}
      <Dialog
        open={openCatalogTypeDialog}
        onClose={handleCloseCatalogTypeDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Select Catalog</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={catalogTypeOptions}
            getOptionLabel={(option) => option.label}
            value={selectedCatalogType}
            onChange={(event, newValue) => {
              if (newValue) {
                handleCatalogTypeSelect(newValue);
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Catalog Type"
                placeholder="Choose a catalog type"
                required
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCatalogTypeDialog} variant="outlined" color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Modal
        modalTitle={"Edit Product Formula"}
        open={openRecipeModal}
        handleClose={() => setOpenRecipeModal(false)}
        width={1200}
      >
        <JobCost 
          fromSplitEstimate={false}
          formulaName={localData?.name || null}
          onRecipeCreated={handleRecipeUpdated}
          setRecipes={() => {}}
          formulaTab={localData?.type === 1 ? 'production' : localData?.type === 2 ? 'traffic' : 'split'}
          recipeId={formulaId}
          fromAddProductsEdit={true}
          hideSaveAsCopy={true}
        />
      </Modal>

      {/* Catalog Modal for Adding Product from Recipe */}
      <Dialog
        open={openCatalogModal}
        onClose={() => {
          setOpenCatalogModal(false);
          setSelectedRecipeForCatalog(null);
          setSelectedCatalogType(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Add Catalog</DialogTitle>
        <DialogContent>
          <AddProducts 
            fromSplitEstimate={false}
            modalInhouse={localData?.type === 3 
              ? 6 
              : localData?.type === 2 
                ? 1 
                : selectedCatalogType?.inhouse || true}
            modalSelectedTab={localData?.type === 3 
              ? 'split_catalog' 
              : localData?.type === 2
                ? undefined
                : selectedCatalogType?.selectedTab}
            modalIsTrafficCatalog={localData?.type === 2}
            modalTimeAndMaterial={false}
            onClose={() => {
              setOpenCatalogModal(false);
              setSelectedRecipeForCatalog(null);
              setSelectedCatalogType(null);
            }}
            productName={selectedRecipeForCatalog?.name || ''}
            RecipeId={selectedRecipeForCatalog?.id || null}
            fromRecipeList={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenCatalogModal(false);
            setSelectedRecipeForCatalog(null);
            setSelectedCatalogType(null);
          }} variant="outlined" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Modal
        modalTitle={'View Material'}
        open={viewData ? true : false}
        handleClose={() => {
          setViewData(null);
        }}
        width={1000}
      >
        <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
          <Grid item xs={12} md={12}>
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              spacing={3}
            >
              <Paper
                key={'view-material-paper'}
                sx={{
                  p: 3,
                  width: 1,
                  bgcolor: 'background.neutral'
                }}
              >

                <Grid container spacing={2} >
                  <Tabs
                    value={currentTab}
                    scrollButtons="auto"
                    variant="scrollable"
                    allowScrollButtonsMobile
                    onChange={handleChangeTab}
                    sx={{ mb: 2.5 }}
                  >
                    {ACCOUNT_TABS.map((tab) => (
                      <Tab sx={{
                        justifyContent: 'center',
                        marginX: 6,
                        mt: 2.5,
                        overflow: 'visible'
                      }}
                        disableRipple
                        key={tab.value}
                        label={
                          <Typography variant="overline">{capitalCase(tab.value)}</Typography>
                        }
                        icon={tab.icon}
                        value={tab.value}
                      />
                    ))}
                  </Tabs>
                  {ACCOUNT_TABS.map((tab) => {
                    const isMatched = tab.value === currentTab;
                    return isMatched &&
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }} key={tab.value}>
                        {currentTab == 'Finished Products' ?
                          <MaterialFinishedProducts prodId={viewData?.id} viewFinishedProducts={true} unitName={resolvedViewUnitName} unit={viewData?.unit} unitQty={viewData?.unit_qty} expectedPrice={viewData?.price} vpt_number={viewData?.vpt_number} viewData={viewData} description={viewData?.description} fromTask={true} />
                          // <MaterialFinishedProducts prodId={viewData?.id} viewFinishedProducts={true} unitName={viewData?.unit_name} unitQty={viewData?.unit_qty} />
                          :
                          <MaterialPartialFinishedProducts prodId={viewData?.id} viewFinishedProducts={true} unitName={resolvedViewUnitName} unit={viewData?.unit} unitQty={viewData?.unit_qty} expectedPrice={viewData?.price} vpt_number={viewData?.vpt_number} description={viewData?.description} fromTask={true} />
                        }
                      </Box>
                  })}
                </Grid>
              </Paper>
              <Box
                sx={{
                  mt: 3,
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => {
                    setViewData(null);
                  }}
                >
                  Close
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Modal>

      <Dialog
        open={isViewMaterialLoading && !viewData}
        PaperProps={{
          sx: {
            px: 4,
            py: 3,
            borderRadius: 2,
            textAlign: 'center',
            minWidth: 280,
          },
        }}
      >
        <Stack spacing={1.5} alignItems="center" justifyContent="center">
          <Box
            sx={{
              position: 'relative',
              width: 56,
              height: 56,
              '@keyframes materialOpenSpin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
              },
              '@keyframes materialOpenPulse': {
                '0%, 100%': { transform: 'translate(-50%, -50%) scale(0.75)', opacity: 0.6 },
                '50%': { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 },
              },
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: '50%',
                border: '3px solid',
                borderColor: 'primary.main',
                opacity: 0.2,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                borderRadius: '50%',
                border: '3px solid',
                borderColor: 'primary.main',
                borderTopColor: 'transparent',
                animation: 'materialOpenSpin 0.9s linear infinite',
              }}
            />
            {/* <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                animation: 'materialOpenPulse 1.2s ease-in-out infinite',
              }}
            /> */}
          </Box>
          <Typography variant="subtitle2">Opening material details...</Typography>
        </Stack>
      </Dialog>
      <SendDesignsEmailModal
        open={openInvoiceEmailModal}
        onClose={() => setOpenInvoiceEmailModal(false)}
        selectedDesigns={invoicePdfData}
        requestId={formulaId}
        userId={user?.user_id}
        userType={user?.user_type}
        invoice={{}}
        details={{ name: localData?.name || 'Product Formula' }}
        pageType="product_formula"
        REST_API={REST_API_END_POINT}
        onSuccess={() => setInvoicePdfData([])}
      />
    </Modal>
  );
}
